import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";

import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  ButtonGroup,
  useMediaQuery,
  Menu,
  MenuItem,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  CircularProgress,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Popover,
  Chip,
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  Block,
  DonutSmall,
  VerifiedUser,
  FilterList,
  Equalizer,
  DonutLarge,
  Assignment,
  Close,
  MoreVert, Launch, BusinessCenter
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import Format from "date-fns/format";

import { Skeleton, Pagination } from "@material-ui/lab";

import Empty from "../../../assets/svg/empty.svg";

import { makeStyles, useTheme } from "@material-ui/styles";
import OperatorLogo from "../../../assets/img/operator.jpg";

import OperatorDetails from "./operator_details";
import {useGetOrganization} from './../hooks/use_hooks'


import { useCommissions, useLicenses } from "../hooks/use_hooks";

import { AdminService, TransportService,Permissions } from "./../../../utils/web_config";
import { tickets } from "../../operator/summary_report";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  holder: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: -250,
    },
  },
  tabs: {
    marginTop: -theme.spacing(3),
    marginLeft: -16,
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    marginRight: 10,
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
  logo: {
    borderRadius: 10,
  },
}));



function OperatorHome(props) {
  const classes = useStyles();
  const history = useHistory();

  const getOrganization =useGetOrganization({id:history.location?.state?.organization_id})

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  const [menuOpen, setMenuOpen] = useState(null);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [accountData, setAccountData] = useState({});

  const [button, setButton] = useState(0)
  // const commissions = usecommissions({
  //   id: history.location.state.organization_id,
  // });
  const allCommissions = useCommissions();

  const [licenses, setLicenses] = useState({
    status: "loading",
    loading: false,
    saving: false,
    open: false,
    data: [],
  });
  const [commissions, setCommissions] = useState({
    status: "loading",
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [operators, setOperators] = useState({
    loading2: false,
  })





  const [operator, setOperator] = useState({});

  const [commissionChannelType, setChannelType] = useState({
    value: "",
    error: "",
  });
  const [commissionCommission, setCommission] = useState({
    value: "",
    error: "",
  });
  const [commissionDiscount, setDiscount] = useState({ value: "", error: "" });

  const [licenseIssueDate, setIssueDate] = useState({
    value: new Date(),
    error: "",
  });
  const [licenseExpiryDate, setExpiryDate] = useState({
    value: new Date(),
    error: "",
  });
  const [licenseLicenseNumber, setLicenseNumber] = useState({
    value: "",
    error: "",
  });

  const [licenseRoutes, setRoutes] = useState({ data: [] });

  const [licenseOrigin, setLicenseOrigin] = useState({
    value: "",
    error: "",
  });

  const [licenseDestination, setLicenseDestination] = useState({
    value: "",
    error: "",
  });

  useEffect(() => {
    setOperator(history.location.state);
    var accountData = new AdminService().accountData;
    setAccountData(accountData);

    getLicenses(history.location?.state?.organization_id, accountData.token);
    getCommissions(history.location?.state?.organization_id, accountData.token);

    getOperatorFromTransport(history.location?.state?.organization_id, accountData.token)
  }, []);


  ///////////////////////////////////////////////

  const onIssueDateChange = (date) => {
    setIssueDate({ value: date, error: "" });
  };
  const onExpiryDateChange = (date) => {
    setExpiryDate({ value: date, error: "" });
  };
  const onLicenseNumberChange = (event) => {
    if (event.target.value === "") {
      setLicenseNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.license_license_number")
            }
          </Translate>
        ),
      });
    } else {
      setLicenseNumber({ value: event.target.value, error: "" });
    }
  };


  const onOrigin = (event) => {
    if (event.target.value === "") {
      setLicenseOrigin({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.license_origin")
            }
          </Translate>
        ),
      });
    } else {
      setLicenseOrigin({ value: event.target.value, error: "" });
    }
  };

  const onDestination = (event) => {
    if (event.target.value === "") {
      setLicenseDestination({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.license_destination")
            }
          </Translate>
        ),
      });
    } else {
      setLicenseDestination({ value: event.target.value, error: "" });
    }
  };
  ///////////////////////
  const onCreateClick = () => {
    if (licenseIssueDate.value === "") {
      setIssueDate({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.license_issue_date")
            }
          </Translate>
        ),
      });
    } else if (licenseExpiryDate.value === "") {
      setExpiryDate({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.license_expiry_date")
            }
          </Translate>
        ),
      });
    } else if (licenseLicenseNumber.value === "") {
      setLicenseNumber({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.license_license_number")
            }
          </Translate>
        ),
      });
    } else if (licenseRoutes.data?.length == 0) {
      notify('error', "Please add license routes")
    } else {
      createLicense();
    }
  };
  ///////////////////////////

  const onChannelTypeChange = (event) => {
    if (event.target.value === "") {
      setChannelType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.commission_channel_type")
            }
          </Translate>
        ),
      });
    } else {
      setChannelType({ value: event.target.value, error: "" });
    }
  };
  const onCommissionChange = (event) => {
    if (event.target.value === "") {
      setCommission({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.commission_commission")
            }
          </Translate>
        ),
      });
    } else {
      setCommission({ value: event.target.value, error: "" });
    }
  };
  const onDiscountChange = (event) => {
    if (event.target.value === "") {
      setDiscount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.commission_discount")
            }
          </Translate>
        ),
      });
    } else {
      setDiscount({ value: event.target.value, error: "" });
    }
  };
  ////////////////////

  const onCreateCommClick = () => {
    if (commissionChannelType.value === "") {
      setChannelType({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.commission_channel_type")
            }
          </Translate>
        ),
      });
    } else if (commissionCommission.value === "") {
      setCommission({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.commission_commission")
            }
          </Translate>
        ),
      });
    } else if (commissionDiscount.value === "") {
      setDiscount({
        value: "",
        error: (
          <Translate>
            {({ translate }) =>
              translate("operator_home.forms.hints.commission_discount")
            }
          </Translate>
        ),
      });
    } else {
      createCommission();
    }
  };

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  ///////////////           Get operator from transport      ////////////////////

  const getOperatorFromTransport = (id, token) => {
    const getInstance = axios.create(new AdminService().getHeaders(token));
    setOperators({ ...operators, loading2: true });

    console.log("getting operators from transport.....");

    getInstance
      .get(
        new TransportService().GET_ORGANIZATION_BY_ADMIN_ID + id
      )
      .then(function (response) {
        setOperators({ ...operators, loading2: false });

        const d = response.data;
        const myData = new AdminService().accountData
        var myOrg = myData.organization
        myOrg['organization_id'] = d.admin_id
        myOrg['name'] = d.names

        myOrg['tp']=d['organization_type']
        myData['organization'] = myOrg

        localStorage.setItem("profile", JSON.stringify({ operator: d }))
        localStorage.setItem('nx_op', JSON.stringify(myData))


      })
      .catch(function (error) {
        setOperators({ ...operators, loading2: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  const clearLicForm = () => {
    setRoutes({ data: [] });
    setLicenseNumber({ value: "", error: "" });
  };

  ////////////////////////////

  const createLicense = () => {
    const roleInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setLicenses({ ...licenses, saving: true });

    console.log("Create license.....");

    const data = {
      expiry_date: Format(licenseExpiryDate.value, ["yyyy-MM-dd HH:mm:ss"]),
      issue_date: Format(licenseIssueDate.value, ["yyyy-MM-dd HH:mm:ss"]),
      license_number: licenseLicenseNumber.value,
      organization_id: operator.organization_id,
      routes: JSON.stringify(licenseRoutes.data),
    };
    const url = new AdminService().CREATE_LICENSE;
    roleInstance
      .post(url, data)
      .then(function (response) {
        const d = response.data;

        var lics = licenses.data;
        lics.unshift(d.data);

        setLicenses({
          ...licenses,
          data: lics,
          status: "success",
          saving: false,
          acnhor: null,
        });

        notify("success", d.message);

        clearLicForm();
      })
      .catch(function (error) {
        setLicenses({ ...licenses, saving: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ////////////////////////////

  const clearCommForm = () => {
    setChannelType({ value: "", error: "" });
    setDiscount({ value: "", error: "" });
    setDiscount({ value: "", error: "" });
  };

  const createCommission = () => {
    const roleInstance = axios.create(
      new AdminService().getHeaders(accountData.token)
    );

    setCommissions({ ...commissions, saving: true });

    console.log("Create comm.....");

    const data = {
      channel_type: commissionChannelType.value,
      commission_id: commissionCommission.value,
      discount: commissionDiscount.value,
      organization_id: operator.organization_id,
    };

    const url = new AdminService().CREATE_ORGANIZATION_COMMISSION;
    roleInstance
      .post(url, data)
      .then(function (response) {
        const d = response.data;

        var comms = commissions.data;
        comms.unshift(d.data);

        setCommissions({
          ...commissions,
          data: comms,
          status: "success",
          saving: false,
          acnhor: null,
        });

        notify("success", d.message);

        clearCommForm();
      })
      .catch(function (error) {
        setCommissions({ ...commissions, saving: false });

        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  /////////////////////////////////////////////////////////////////////////////////////

  const getCommissions = (id, token) => {
    const typesInstance = axios.create(new AdminService().getHeaders(token));

    const url =
      id == null
        ? new AdminService().GET_ORGANIZATION_COMMISSIONS
        : new AdminService().GET_ORGANIZATION_COMMISSION_BY_ORGANIZATION_ID +
        id;
    typesInstance
      .get(url)
      .then(function (response) {
        const d = response.data;
        setCommissions({ data: d.data, status: "success" });
      })
      .catch(function (error) {
        if (error.response) {
          if (error?.response?.status == 404) {
            setCommissions({ data: [], status: "empty" });
          } else {
            setCommissions({ data: [], status: "error" });
          }
        } else {
          setCommissions({ data: [], status: "error" });
        }
      });

    ////
  };

  /////////////////////////////////////////////
  const getLicenses = (id, token) => {
    const licInstance = axios.create(new AdminService().getHeaders(token));

    const url =
      id == null
        ? new AdminService().GET_ALL_LICENSES
        : new AdminService().GET_LICENSE_BY_ORGANIZATION_ID + id;

    licInstance
      .get(url)
      .then(function (response) {
        const d = response.data;
        setLicenses({ data: d.data, status: "success" });
      })
      .catch(function (error) {
        if (error.response) {
          if (error?.response?.status == 404) {
            setLicenses({ data: [], status: "empty" });
          } else {
            setLicenses({ data: [], status: "error" });
          }
        } else {
          setLicenses({ data: [], status: "error" });
        }
      });

    ////
  };

  const parseRoutes = (json) => {

    try {
      var a = JSON.parse(json);
      return a
    } catch (e) {
      return []

    }
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.root}>
        {/* Dialogs ends here */}

        {/* /////////////////////////////// */}
        <Box className={classes.tabs}>
          <Paper square elevation={0} style={{ marginRight: -16 }}>
            <Box display="flex" alignItems="center" pt={2}>
              <Box ml={2} mr={2} pb={1} pt={1}>
                {getOrganization?.data?.logo_file_byte!=null?<img
                  src={"data:image/jpg;base64," +getOrganization?.data?.logo_file_byte}
                  alt="Logo"
                  height={80}
                  className={classes.logo}
                />:<BusinessCenter fontSize="large" />}
              </Box>

              <Typography variant="h5" className={classes.title}>
                <b>{operator.name}</b>
              </Typography>
              {!matches ? (
                <>
                  <IconButton onClick={(e) => setMenuOpen(e.currentTarget)}>
                    <MoreVert />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={menuOpen}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    open={menuOpen != null}
                    onClose={() => setMenuOpen(null)}
                  >
                    <MenuItem
                       onClick={() => history.push('/centrika/operator')}
                    >
                     Open portal
                    </MenuItem>
                    
                  </Menu>
                </>
              ) : (
                  <Box display="flex" height="40px" mr={3}>
                  <Permissions permissions="CAN_VIEW_OPERATOR">  <Button
                      className={classes.btn}
                      color="primary"
                      variant="outlined"
                      size="medium"
                      endIcon={<Launch />}
                      disableElevation
                      onClick={() => history.push('/centrika/operator')}
                      disabled={operators.loading2}
                    >
                      Open portal
                  </Button>
                  </Permissions>

                  </Box>
                )}
            </Box>
          </Paper>
        </Box>

        {/* ////////////////////// */}
        <Popover
          id={"pop-id"}
          open={licenses.acnhor != null}
          anchorEl={licenses.acnhor}
          onClose={() => setLicenses({ ...licenses, acnhor: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          elevation={4}
        >
          <Box p={2}>
            <Typography color="textSecondary">
              Create new operator license from RURA, all info must be valid..
            </Typography>

            <Box mt={2}>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                label={
                  <Translate id="operator_home.forms.labels.license_issue_date" />
                }
                value={licenseIssueDate.value}
                inputVariant="outlined"
                onChange={onIssueDateChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
            <Box mt={2}>
              <DatePicker
                fullWidth
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="dense"
                autoOk
                label={
                  <Translate id="operator_home.forms.labels.license_expiry_date" />
                }
                value={licenseExpiryDate.value}
                inputVariant="outlined"
                onChange={onExpiryDateChange}
                InputProps={{
                  disableUnderline: true,
                  style: { paddingRight: 0 },
                }}
              />
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={licenseLicenseNumber.value}
                    placeholder={translate(
                      "operator_home.forms.hints.license_license_number"
                    )}
                    label={
                      <Translate id="operator_home.forms.labels.license_license_number" />
                    }
                    fullWidth
                    onChange={onLicenseNumberChange}
                    helperText={licenseLicenseNumber.error}
                    error={licenseLicenseNumber.error !== ""}
                  />
                )}
              </Translate>
            </Box>

            <List dense>
              {
                licenseRoutes.data?.map((l, i) => <Box p={1} mt={1} display='flex' border={1} borderRadius='borderRadius' justifyContent='space-between'>

                  <Typography>{l.origin}</Typography>
                  <Typography color='primary'>To</Typography>
                  <Typography>{l.dest}</Typography>

                </Box>)
              }
            </List>

            <Box >
              <Typography color="textSecondary">
                Write route origin and destination
          </Typography>
              <Box mt={2} mb={2} display='flex' justifyContent='space-between'>
                <TextField
                  label="Origin"
                  placeholder="Route origin"

                  fullWidth
                  variant="outlined"
                  size='small'
                  value={licenseOrigin.value}
                  onChange={onOrigin}
                  error={licenseOrigin.error != ""}
                  helperText={licenseOrigin.error}
                />
                <Box pl={2} />
                <TextField
                  label="Destination"
                  placeholder="Route origin"

                  fullWidth
                  variant="outlined"
                  size='small'
                  value={licenseDestination.value}
                  onChange={onDestination}
                  error={licenseDestination.error != ""}
                  helperText={licenseDestination.error}
                />
                <IconButton onClick={() => {

                  if (licenseOrigin.value != '' && licenseDestination.value != '') {
                    const d = licenseRoutes.data
                    d.push({ origin: licenseOrigin.value, dest: licenseDestination.value })
                    setRoutes({ data: d })

                    setLicenseOrigin({ value: '', error: '' })
                    setLicenseDestination({ value: '', error: '' })
                    setLicenses({ ...licenses, acnhor2: null })
                  }
                }} color='primary'><Add /></IconButton>
              </Box>


            </Box>


            <Box display="flex" mt={2}>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                className={classes.btn}
                onClick={() => setLicenses({ ...licenses, acnhor: null })}
              >
                Cancel
              </Button>
              <Box mr={2} />
              <Button
                disabled={licenses.saving}
                variant="contained"
                color="primary"
                className={classes.btn}
                disableElevation
                onClick={() => {
                  onCreateClick();
                }}
              >
                {licenses.saving ? <CircularProgress size={23} /> : "Save"}
              </Button>
            </Box>
          </Box>
        </Popover>


        {/* ////////////////////////////////// */}

        <Popover
          id={"pop-id"}
          open={licenses.acnhor2 != null}
          anchorEl={licenses.acnhor2}
          onClose={() => setLicenses({ ...licenses, acnhor2: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          elevation={4}
        >
          <Box p={2}>
            <Typography color="textSecondary">
              Write route origin and destination
          </Typography>
            <Box mt={2} mb={2} display='flex' justifyContent='space-between'>
              <TextField
                label="Origin"
                placeholder="Route origin"

                fullWidth
                variant="outlined"
                size='small'

                onChange={onOrigin}
                error={licenseOrigin.error != ""}
                helperText={licenseOrigin.error}
              />
              <Box pl={2} />
              <TextField
                label="Destination"
                placeholder="Route origin"

                fullWidth
                variant="outlined"
                size='small'

                onChange={onDestination}
                error={licenseDestination.error != ""}
                helperText={licenseDestination.error}
              />
            </Box>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              className={classes.btn2}
              onClick={() => setLicenses({ ...licenses, acnhor2: null })}
            >
              Close
          </Button>
            <Button

              variant="contained"
              size="small"
              color="primary"
              className={classes.btn}
              disableElevation
              onClick={() => {

                if (licenseOrigin.value != '' && licenseDestination.value != '') {
                  const d = licenseRoutes.data
                  d.push({ origin: licenseOrigin.value, dest: licenseDestination.value })
                  setRoutes({ data: d })

                  setLicenses({ ...licenses, acnhor2: null })
                }
              }}
            >
              Add route
            </Button>
          </Box>
        </Popover>

        {/* ////////////////////// */}
        <Popover
          id={"pop-id"}
          open={commissions.acnhor != null}
          anchorEl={commissions.acnhor}
          onClose={() => setCommissions({ ...commissions, acnhor: null })}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          elevation={4}
        >
          <Box p={2}>
            <Typography color="textSecondary">
              Add new operator commission, fill all information to complete.
            </Typography>

            <Box mt={3}>
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                error={commissionChannelType.error !== ""}
              >
                <InputLabel>
                  <Translate id="operator_home.forms.labels.commission_channel_type" />
                </InputLabel>
                <Select
                  label={
                    <Translate id="operator_home.forms.labels.commission_channel_type" />
                  }
                  value={commissionChannelType.value}
                  onChange={onChannelTypeChange}
                >
                  {["WEB", "APP", "KIOSK", "POS", "CARD"].map((tp, i) => (
                    <MenuItem value={tp}>{tp}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{commissionChannelType.error}</FormHelperText>
              </FormControl>
            </Box>
            <Box mt={2}>
              <FormControl
                fullWidth
                variant="outlined"
                size="small"
                error={
                  commissionCommission.error !== "" ||
                  allCommissions.status == "empty" ||
                  allCommissions.status == "error"
                }
                disabled={allCommissions.status == "loading"}
              >
                <InputLabel>
                  <Translate id="operator_home.forms.labels.commission_commission" />
                </InputLabel>
                <Select
                  label={
                    <Translate id="operator_home.forms.labels.commission_commission" />
                  }
                  value={commissionCommission.value}
                  onChange={onCommissionChange}
                  disabled={allCommissions.status != "success"}
                >
                  {allCommissions.data?.map((comm, i) => (
                    <MenuItem value={comm.id}>{comm.name}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>
                  {allCommissions.status == "empty"
                    ? "There is no account commission available, create one in accounts"
                    : allCommissions.status == "error"
                      ? "Error loading account commissions, try reloading"
                      : commissionCommission.error}
                </FormHelperText>
              </FormControl>
            </Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={commissionDiscount.value}
                    placeholder={translate(
                      "operator_home.forms.hints.commission_discount"
                    )}
                    label={
                      <Translate id="operator_home.forms.labels.commission_discount" />
                    }
                    fullWidth
                    onChange={onDiscountChange}
                    helperText={commissionDiscount.error}
                    error={commissionDiscount.error !== ""}
                  />
                )}
              </Translate>
            </Box>
            <Box display="flex" mt={2}>
              <Button
                variant="outlined"
                size="small"
                color="primary"
                className={classes.btn}
                onClick={() => setCommissions({ ...commissions, acnhor: null })}
              >
                Cancel
              </Button>
              <Box mr={2} />
              <Button
                disabled={commissions.saving}
                variant="contained"
                color="primary"
                className={classes.btn}
                disableElevation
                onClick={() => {
                  onCreateCommClick();
                }}
              >
                {commissions.saving ? <CircularProgress size={23} /> : "Save"}
              </Button>
            </Box>
          </Box>
        </Popover>

        <Grid container spacing={2}>

          <Grid item xs={12} md={6}>

            <Box pt={4} display='flex' alignItems='center' flexDirection='column'>
              <ButtonGroup color='primary' >
                <Button className={classes.btn} variant={button == 0 ? 'contained' : 'outlined'} onClick={() => setButton(0)}>Operator licenses</Button>
                <Button className={classes.btn} variant={button == 1 ? 'contained' : 'outlined'} onClick={() => setButton(1)}>Operator commissions</Button>
              </ButtonGroup>

              <Box mt={2} width={1}>
                {
                  button == 0 ? <><DialogTitle id="alert-dialog-title">
                    {
                      <Box display="flex" alignItems="center">
                        <Box flexGrow={1}>Licenses</Box>

                        <Button
                          color="primary"
                          variant='outlined'
                          className={classes.btn}
                          startIcon={<Add />}
                          onClick={(e) =>
                            setLicenses({
                              ...licenses,
                              acnhor: e.currentTarget,
                            })
                          }
                        >
                          New license
                </Button>
                      </Box>
                    }
                  </DialogTitle>
                    <Box >
                      {licenses.status == "error" || licenses.status == "empty" ? (
                        <Box p={5} display="flex" justifyContent="center">
                          {licenses.status == "error" ? (
                            <Box
                              p={2}
                              mt={3}
                              height={1}
                              display="flex"
                              alignItems="center"
                              flexDirection="column"
                              justifyContent="center"
                            >
                              <Box mt={2}>
                                <img src={Empty} alt="Empty data" height={200} />
                              </Box>
                              <Typography color="textSecondary">
                                Error loading licenses, please try agai later.
                </Typography>
                            </Box>
                          ) : (
                              <Box
                                p={2}
                                mt={3}
                                height={1}
                                display="flex"
                                alignItems="center"
                                flexDirection="column"
                                justifyContent="center"
                              >
                                <Box mt={2}>
                                  <img src={Empty} alt="Empty data" height={200} />
                                </Box>
                                <Typography color="textSecondary">
                                  There are no Licenses for <b> {operator.name} </b> yet.
                </Typography>
                              </Box>
                            )}
                        </Box>
                      ) : (
                          <List>
                            {licenses.status != "loading"
                              ? licenses.data.map((lic, i) => (
                                <>
                                  {i != 0 && i != licenses.data.length && (
                                    <Divider variant="middle" />
                                  )}
                                  <ListItem key={i} dense button>
                                    <ListItemIcon>
                                      <VerifiedUser />
                                    </ListItemIcon>
                                    <ListItemText
                                      primary={"License number: " + lic.license_number}
                                      secondary={
                                        "Expire: " + lic.expiry_date
                                      }
                                    />
                                    <ListItemSecondaryAction>
                                      <Typography
                                        color={
                                          lic.license_status == "EXPIRED"
                                            ? "error"
                                            : "primary"
                                        }
                                      >
                                        {lic.license_status}
                                      </Typography>
                                    </ListItemSecondaryAction>

                                  </ListItem>

                                  <Box ml={8}> <Typography>
                                    Assigned routes
                       </Typography>
                                  </Box>
                                  {
                                    parseRoutes(lic.routes).length != 0 ? <List dense>
                                      {
                                        parseRoutes(lic.routes)?.map((l, i) => <Box p={1} mt={1} ml={8} display='flex' border={1} borderRadius='borderRadius' justifyContent='space-between'>

                                          <Typography>{l.origin}</Typography>
                                          <Typography color='primary'>To</Typography>
                                          <Typography>{l.dest}</Typography>

                                        </Box>)
                                      }
                                    </List> : <Box ml={8} mt={2}>  <Typography color='textSecondary'>License routes not available</Typography></Box>
                                  }
                                </>
                              ))
                              : [1, 2, 3, 4, 5].map((item, i) => (
                                <ListItem key={i}>
                                  <ListItemText
                                    primary={
                                      <Skeleton
                                        variant="text"
                                        width={"100%"}
                                        style={{ borderRadius: 7 }}
                                      />
                                    }
                                  />
                                </ListItem>
                              ))}
                          </List>
                        )}
                    </Box>
                  </> : <> <DialogTitle id="alert-dialog-title">
                    {
                      <Box display="flex" alignItems="center">
                        <Box flexGrow={1}>Commissions</Box>

                        <Button
                          color="primary"
                          variant='outlined'
                          className={classes.btn}
                          startIcon={<Add />}
                          onClick={(e) =>
                            setCommissions({
                              ...commissions,
                              acnhor: e.currentTarget,
                            })
                          }
                        >
                          New commission
                </Button>
                      </Box>
                    }
                  </DialogTitle>
                      <Box>
                        {commissions.status == "error" || commissions.status == "empty" ? (
                          <Box p={5} display="flex" justifyContent="center">
                            {commissions.status == "error" ? (
                              <Box
                                p={2}
                                mt={3}
                                height={1}
                                display="flex"
                                alignItems="center"
                                flexDirection="column"
                                justifyContent="center"
                              >
                                <Box mt={2}>
                                  <img src={Empty} alt="Empty data" height={200} />
                                </Box>
                                <Typography color="textSecondary">
                                  Error loading commissions, try again later
                </Typography>
                              </Box>
                            ) : (<Box
                              p={2}
                              mt={3}
                              height={1}
                              display="flex"
                              alignItems="center"
                              flexDirection="column"
                              justifyContent="center"
                            >
                              <Box mt={2}>
                                <img src={Empty} alt="Empty data" height={200} />
                              </Box>
                              <Typography color="textSecondary">
                                There are no commissions for <b> {operator.name} </b> yet.
                </Typography>
                            </Box>

                              )}
                          </Box>
                        ) : (
                            <List>
                              {commissions.status != "loading"
                                ? commissions.data.map((comm, i) => (
                                  <>
                                    {i != 0 && i != commissions.data.length && (
                                      <Divider variant="middle" />
                                    )}
                                    <ListItem key={i} dense button>
                                      <ListItemIcon>
                                        <DonutSmall />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={"Channel: " + comm.channel_type}
                                        secondary={"Discount: " + comm.discount}
                                      />
                                      <ListItemSecondaryAction>
                                        <Switch
                                          color="primary"
                                          checked={comm.commission_status == "ENABLED"}
                                        />
                                      </ListItemSecondaryAction>
                                    </ListItem>
                                  </>
                                ))
                                : [1, 2, 3, 4, 5].map((item, i) => (
                                  <ListItem key={i}>
                                    <ListItemText
                                      primary={
                                        <Skeleton
                                          variant="text"
                                          width={"100%"}
                                          style={{ borderRadius: 7 }}
                                        />
                                      }
                                    />
                                  </ListItem>
                                ))}
                            </List>
                          )}
                      </Box>
                    </>
                }
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>

            <OperatorDetails data={history.location.state} logo={getOrganization?.data?.logo_file_byte}/>
          </Grid>
        </Grid>

      </div>
    </MuiPickersUtilsProvider>
  );
}


export default withLocalize(OperatorHome);
